export default __webpack_public_path__ + "static/media/simrunChopra3.247a3692.jpg";